// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/customer.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { GetDealResponse } from "./deal_pb";
import { file_api_proto_v1_deal } from "./deal_pb";
import type { CustomerType, FormGroup } from "./form_pb";
import { file_api_proto_v1_form } from "./form_pb";
import type { Order } from "./list_pb";
import { file_api_proto_v1_list } from "./list_pb";
import type { GetStaffResponse } from "./staff_pb";
import { file_api_proto_v1_staff } from "./staff_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/customer.proto.
 */
export const file_api_proto_v1_customer: GenFile = /*@__PURE__*/
  fileDesc("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", [file_api_proto_v1_deal, file_api_proto_v1_form, file_api_proto_v1_list, file_api_proto_v1_staff, file_google_protobuf_timestamp, file_google_protobuf_wrappers]);

/**
 * @generated from message api_proto.v1.GetCustomerBusinessInfoResponse
 */
export type GetCustomerBusinessInfoResponse = Message<"api_proto.v1.GetCustomerBusinessInfoResponse"> & {
  /**
   * @generated from field: string hp = 1;
   */
  hp: string;

  /**
   * @generated from field: string description_of_business = 2;
   */
  descriptionOfBusiness: string;

  /**
   * @generated from field: string fiscal_year_end = 3;
   */
  fiscalYearEnd: string;

  /**
   * @generated from field: string number_of_employees = 4;
   */
  numberOfEmployees: string;

  /**
   * @generated from field: string main_contact_person = 5;
   */
  mainContactPerson: string;
};

/**
 * Describes the message api_proto.v1.GetCustomerBusinessInfoResponse.
 * Use `create(GetCustomerBusinessInfoResponseSchema)` to create a new message.
 */
export const GetCustomerBusinessInfoResponseSchema: GenMessage<GetCustomerBusinessInfoResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 0);

/**
 * @generated from message api_proto.v1.GetCustomerResponse
 */
export type GetCustomerResponse = Message<"api_proto.v1.GetCustomerResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kana = 3;
   */
  kana: string;

  /**
   * @generated from field: string name_full = 4;
   */
  nameFull: string;

  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 5;
   */
  staff?: GetStaffResponse;

  /**
   * @generated from field: string app_updated = 6;
   */
  appUpdated: string;

  /**
   * @generated from field: string tel = 7;
   */
  tel: string;

  /**
   * @generated from field: string email = 8;
   */
  email: string;

  /**
   * @generated from field: string registration_date = 9;
   */
  registrationDate: string;

  /**
   * @generated from field: api_proto.v1.CustomerRank rank = 10;
   */
  rank: CustomerRank;

  /**
   * @generated from field: string tel_sub = 11;
   */
  telSub: string;

  /**
   * @generated from field: string fax = 12;
   */
  fax: string;

  /**
   * @generated from field: string group = 13;
   */
  group: string;

  /**
   * @generated from field: string memo = 14;
   */
  memo: string;

  /**
   * @generated from field: google.protobuf.Timestamp initial_inquiry_date = 15;
   */
  initialInquiryDate?: Timestamp;

  /**
   * @generated from field: string initial_inquiry_source = 16;
   */
  initialInquirySource: string;

  /**
   * @generated from field: string initial_inquiry_source_label = 17;
   */
  initialInquirySourceLabel: string;

  /**
   * @generated from field: string initial_inquiry_source_detail = 18;
   */
  initialInquirySourceDetail: string;

  /**
   * @generated from field: string initial_inquiry_detail = 19;
   */
  initialInquiryDetail: string;

  /**
   * @generated from field: string billing_contact_name = 20;
   */
  billingContactName: string;

  /**
   * @generated from field: string billing_tel = 21;
   */
  billingTel: string;

  /**
   * @generated from field: string zipcode = 22;
   */
  zipcode: string;

  /**
   * @generated from field: string prefecture = 23;
   */
  prefecture: string;

  /**
   * @generated from field: string city = 24;
   */
  city: string;

  /**
   * @generated from field: string street = 25;
   */
  street: string;

  /**
   * @generated from field: string family_structure = 27;
   */
  familyStructure: string;

  /**
   * @generated from field: repeated api_proto.v1.GetDealResponse deals = 28;
   */
  deals: GetDealResponse[];

  /**
   * @generated from field: string raw_pref = 29;
   */
  rawPref: string;

  /**
   * @generated from field: bool no_follow = 30;
   */
  noFollow: boolean;

  /**
   * @generated from field: bool no_contact = 31;
   */
  noContact: boolean;

  /**
   * @generated from field: string line = 32;
   */
  line: string;

  /**
   * @generated from field: api_proto.v1.SocialType social_type = 33;
   */
  socialType: SocialType;

  /**
   * @generated from field: google.protobuf.Timestamp birthday = 34;
   */
  birthday?: Timestamp;

  /**
   * @generated from field: string work_for = 35;
   */
  workFor: string;

  /**
   * @generated from field: string flyer_type = 36;
   */
  flyerType: string;

  /**
   * @generated from field: string hp = 37;
   */
  hp: string;

  /**
   * @generated from field: string description_of_business = 38;
   */
  descriptionOfBusiness: string;

  /**
   * @generated from field: string fiscal_year_end = 39;
   */
  fiscalYearEnd: string;

  /**
   * @generated from field: string number_of_employees = 40;
   */
  numberOfEmployees: string;

  /**
   * @generated from field: api_proto.v1.CustomerType customer_type = 41;
   */
  customerType: CustomerType;

  /**
   * @generated from field: api_proto.v1.GetCustomerBusinessInfoResponse business_info = 42;
   */
  businessInfo?: GetCustomerBusinessInfoResponse;
};

/**
 * Describes the message api_proto.v1.GetCustomerResponse.
 * Use `create(GetCustomerResponseSchema)` to create a new message.
 */
export const GetCustomerResponseSchema: GenMessage<GetCustomerResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 1);

/**
 * @generated from message api_proto.v1.GetCustomerListRequest
 */
export type GetCustomerListRequest = Message<"api_proto.v1.GetCustomerListRequest"> & {
  /**
   * @generated from field: int64 page = 1;
   */
  page: bigint;

  /**
   * @generated from field: int64 page_size = 2;
   */
  pageSize: bigint;

  /**
   * @generated from field: bool is_only_has_progress_deal = 3;
   */
  isOnlyHasProgressDeal: boolean;

  /**
   * @generated from field: string customer_name = 4;
   */
  customerName: string;

  /**
   * @generated from field: string tel = 5;
   */
  tel: string;

  /**
   * @generated from field: string email = 6;
   */
  email: string;

  /**
   * @generated from field: int64 company_staff_id = 7;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: string kana = 8;
   */
  kana: string;

  /**
   * @generated from field: api_proto.v1.Order cus_id_order = 9;
   */
  cusIdOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order cus_name_order = 10;
   */
  cusNameOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order com_staff_name_order = 11;
   */
  comStaffNameOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order updated_order = 12;
   */
  updatedOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order kana_order = 13;
   */
  kanaOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order address_order = 14;
   */
  addressOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order tel_order = 15;
   */
  telOrder: Order;

  /**
   * @generated from field: api_proto.v1.Order email_order = 16;
   */
  emailOrder: Order;

  /**
   * @generated from field: bool exclude_no_follow = 17;
   */
  excludeNoFollow: boolean;

  /**
   * @generated from field: string address = 18;
   */
  address: string;
};

/**
 * Describes the message api_proto.v1.GetCustomerListRequest.
 * Use `create(GetCustomerListRequestSchema)` to create a new message.
 */
export const GetCustomerListRequestSchema: GenMessage<GetCustomerListRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 2);

/**
 * @generated from message api_proto.v1.CustomerListResponse
 */
export type CustomerListResponse = Message<"api_proto.v1.CustomerListResponse"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string kana = 3;
   */
  kana: string;

  /**
   * @generated from field: string name_full = 4;
   */
  nameFull: string;

  /**
   * @generated from field: api_proto.v1.GetStaffResponse staff = 5;
   */
  staff?: GetStaffResponse;

  /**
   * @generated from field: string zipcode = 6;
   */
  zipcode: string;

  /**
   * @generated from field: string address = 7;
   */
  address: string;

  /**
   * @generated from field: string tel = 8;
   */
  tel: string;

  /**
   * @generated from field: string email = 9;
   */
  email: string;

  /**
   * @generated from field: string app_updated = 10;
   */
  appUpdated: string;

  /**
   * @generated from field: string prefecture = 11;
   */
  prefecture: string;

  /**
   * @generated from field: string city = 12;
   */
  city: string;

  /**
   * @generated from field: string street = 13;
   */
  street: string;

  /**
   * @generated from field: string group = 15;
   */
  group: string;

  /**
   * @generated from field: string billing_contact_name = 16;
   */
  billingContactName: string;

  /**
   * @generated from field: api_proto.v1.CustomerType customer_type = 17;
   */
  customerType: CustomerType;
};

/**
 * Describes the message api_proto.v1.CustomerListResponse.
 * Use `create(CustomerListResponseSchema)` to create a new message.
 */
export const CustomerListResponseSchema: GenMessage<CustomerListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 3);

/**
 * @generated from message api_proto.v1.GetCustomerListResponse
 */
export type GetCustomerListResponse = Message<"api_proto.v1.GetCustomerListResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.CustomerListResponse customers = 1;
   */
  customers: CustomerListResponse[];

  /**
   * @generated from field: int64 total_page = 2;
   */
  totalPage: bigint;
};

/**
 * Describes the message api_proto.v1.GetCustomerListResponse.
 * Use `create(GetCustomerListResponseSchema)` to create a new message.
 */
export const GetCustomerListResponseSchema: GenMessage<GetCustomerListResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 4);

/**
 * @generated from message api_proto.v1.GetCustomerListCSVResponse
 */
export type GetCustomerListCSVResponse = Message<"api_proto.v1.GetCustomerListCSVResponse"> & {
  /**
   * @generated from field: bytes csv_data = 1;
   */
  csvData: Uint8Array;

  /**
   * @generated from field: int64 total_count = 2;
   */
  totalCount: bigint;

  /**
   * @generated from field: bool has_conversion_error = 3;
   */
  hasConversionError: boolean;
};

/**
 * Describes the message api_proto.v1.GetCustomerListCSVResponse.
 * Use `create(GetCustomerListCSVResponseSchema)` to create a new message.
 */
export const GetCustomerListCSVResponseSchema: GenMessage<GetCustomerListCSVResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 5);

/**
 * @generated from message api_proto.v1.UpdateCustomerBusinessInfoRequest
 */
export type UpdateCustomerBusinessInfoRequest = Message<"api_proto.v1.UpdateCustomerBusinessInfoRequest"> & {
  /**
   * @generated from field: google.protobuf.StringValue hp = 1;
   */
  hp?: string;

  /**
   * @generated from field: google.protobuf.StringValue description_of_business = 2;
   */
  descriptionOfBusiness?: string;

  /**
   * @generated from field: google.protobuf.StringValue fiscal_year_end = 3;
   */
  fiscalYearEnd?: string;

  /**
   * @generated from field: google.protobuf.StringValue number_of_employees = 4;
   */
  numberOfEmployees?: string;

  /**
   * @generated from field: google.protobuf.StringValue main_contact_person = 5;
   */
  mainContactPerson?: string;
};

/**
 * Describes the message api_proto.v1.UpdateCustomerBusinessInfoRequest.
 * Use `create(UpdateCustomerBusinessInfoRequestSchema)` to create a new message.
 */
export const UpdateCustomerBusinessInfoRequestSchema: GenMessage<UpdateCustomerBusinessInfoRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 6);

/**
 * @generated from message api_proto.v1.CreateCustomerRequest
 */
export type CreateCustomerRequest = Message<"api_proto.v1.CreateCustomerRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue group = 2;
   */
  group?: string;

  /**
   * @generated from field: int64 company_staff_id = 3;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: api_proto.v1.CustomerRank rank = 4;
   */
  rank: CustomerRank;

  /**
   * @generated from field: google.protobuf.StringValue tel = 5;
   */
  tel?: string;

  /**
   * @generated from field: google.protobuf.StringValue tel_sub = 6;
   */
  telSub?: string;

  /**
   * @generated from field: google.protobuf.StringValue fax = 7;
   */
  fax?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 8;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.Timestamp initial_inquiry_date = 9;
   */
  initialInquiryDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_source = 10;
   */
  initialInquirySource?: string;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_source_detail = 11;
   */
  initialInquirySourceDetail?: string;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_detail = 12;
   */
  initialInquiryDetail?: string;

  /**
   * @generated from field: google.protobuf.StringValue zipcode = 13;
   */
  zipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue family_structure = 14;
   */
  familyStructure?: string;

  /**
   * @generated from field: google.protobuf.StringValue memo = 15;
   */
  memo?: string;

  /**
   * @generated from field: google.protobuf.StringValue billing_contact_name = 16;
   */
  billingContactName?: string;

  /**
   * @generated from field: google.protobuf.StringValue kana = 18;
   */
  kana?: string;

  /**
   * @generated from field: google.protobuf.StringValue prefecture = 19;
   */
  prefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue city = 20;
   */
  city?: string;

  /**
   * @generated from field: google.protobuf.StringValue street = 21;
   */
  street?: string;

  /**
   * @generated from field: bool no_follow = 23;
   */
  noFollow: boolean;

  /**
   * @generated from field: bool no_contact = 24;
   */
  noContact: boolean;

  /**
   * @generated from field: google.protobuf.StringValue line = 25;
   */
  line?: string;

  /**
   * @generated from field: api_proto.v1.SocialType social_type = 26;
   */
  socialType: SocialType;

  /**
   * @generated from field: google.protobuf.Timestamp birthday = 27;
   */
  birthday?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue work_for = 28;
   */
  workFor?: string;

  /**
   * @generated from field: google.protobuf.StringValue flyer_type = 29;
   */
  flyerType?: string;

  /**
   * @generated from field: google.protobuf.StringValue hp = 30;
   */
  hp?: string;

  /**
   * @generated from field: google.protobuf.StringValue description_of_business = 31;
   */
  descriptionOfBusiness?: string;

  /**
   * @generated from field: google.protobuf.StringValue fiscal_year_end = 32;
   */
  fiscalYearEnd?: string;

  /**
   * @generated from field: google.protobuf.StringValue number_of_employees = 33;
   */
  numberOfEmployees?: string;

  /**
   * @generated from field: api_proto.v1.UpdateCustomerBusinessInfoRequest business_info = 35;
   */
  businessInfo?: UpdateCustomerBusinessInfoRequest;
};

/**
 * Describes the message api_proto.v1.CreateCustomerRequest.
 * Use `create(CreateCustomerRequestSchema)` to create a new message.
 */
export const CreateCustomerRequestSchema: GenMessage<CreateCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 7);

/**
 * @generated from message api_proto.v1.UpdateCustomerRequest
 */
export type UpdateCustomerRequest = Message<"api_proto.v1.UpdateCustomerRequest"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue group = 3;
   */
  group?: string;

  /**
   * @generated from field: int64 company_staff_id = 4;
   */
  companyStaffId: bigint;

  /**
   * @generated from field: api_proto.v1.CustomerRank rank = 5;
   */
  rank: CustomerRank;

  /**
   * @generated from field: google.protobuf.StringValue tel = 6;
   */
  tel?: string;

  /**
   * @generated from field: google.protobuf.StringValue tel_sub = 7;
   */
  telSub?: string;

  /**
   * @generated from field: google.protobuf.StringValue fax = 8;
   */
  fax?: string;

  /**
   * @generated from field: google.protobuf.StringValue email = 9;
   */
  email?: string;

  /**
   * @generated from field: google.protobuf.Timestamp initial_inquiry_date = 10;
   */
  initialInquiryDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_source = 11;
   */
  initialInquirySource?: string;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_source_detail = 12;
   */
  initialInquirySourceDetail?: string;

  /**
   * @generated from field: google.protobuf.StringValue initial_inquiry_detail = 13;
   */
  initialInquiryDetail?: string;

  /**
   * @generated from field: google.protobuf.StringValue zipcode = 14;
   */
  zipcode?: string;

  /**
   * @generated from field: google.protobuf.StringValue family_structure = 15;
   */
  familyStructure?: string;

  /**
   * @generated from field: google.protobuf.StringValue memo = 16;
   */
  memo?: string;

  /**
   * @generated from field: google.protobuf.StringValue billing_contact_name = 17;
   */
  billingContactName?: string;

  /**
   * @generated from field: google.protobuf.StringValue kana = 19;
   */
  kana?: string;

  /**
   * @generated from field: google.protobuf.StringValue prefecture = 20;
   */
  prefecture?: string;

  /**
   * @generated from field: google.protobuf.StringValue city = 21;
   */
  city?: string;

  /**
   * @generated from field: google.protobuf.StringValue street = 22;
   */
  street?: string;

  /**
   * @generated from field: bool no_follow = 24;
   */
  noFollow: boolean;

  /**
   * @generated from field: bool no_contact = 25;
   */
  noContact: boolean;

  /**
   * @generated from field: google.protobuf.StringValue line = 26;
   */
  line?: string;

  /**
   * @generated from field: api_proto.v1.SocialType social_type = 27;
   */
  socialType: SocialType;

  /**
   * @generated from field: google.protobuf.Timestamp birthday = 28;
   */
  birthday?: Timestamp;

  /**
   * @generated from field: google.protobuf.StringValue work_for = 29;
   */
  workFor?: string;

  /**
   * @generated from field: google.protobuf.StringValue flyer_type = 30;
   */
  flyerType?: string;

  /**
   * @generated from field: google.protobuf.StringValue hp = 31;
   */
  hp?: string;

  /**
   * @generated from field: google.protobuf.StringValue description_of_business = 32;
   */
  descriptionOfBusiness?: string;

  /**
   * @generated from field: google.protobuf.StringValue fiscal_year_end = 33;
   */
  fiscalYearEnd?: string;

  /**
   * @generated from field: google.protobuf.StringValue number_of_employees = 34;
   */
  numberOfEmployees?: string;

  /**
   * @generated from field: api_proto.v1.UpdateCustomerBusinessInfoRequest business_info = 36;
   */
  businessInfo?: UpdateCustomerBusinessInfoRequest;
};

/**
 * Describes the message api_proto.v1.UpdateCustomerRequest.
 * Use `create(UpdateCustomerRequestSchema)` to create a new message.
 */
export const UpdateCustomerRequestSchema: GenMessage<UpdateCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 8);

/**
 * 顧客作成画面
 *
 * @generated from message api_proto.v1.GetCustomerFormRequest
 */
export type GetCustomerFormRequest = Message<"api_proto.v1.GetCustomerFormRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetCustomerFormRequest.
 * Use `create(GetCustomerFormRequestSchema)` to create a new message.
 */
export const GetCustomerFormRequestSchema: GenMessage<GetCustomerFormRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 9);

/**
 * @generated from message api_proto.v1.GetCustomerFormGroupsResponse
 */
export type GetCustomerFormGroupsResponse = Message<"api_proto.v1.GetCustomerFormGroupsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.FormGroup form_groups = 1;
   */
  formGroups: FormGroup[];
};

/**
 * Describes the message api_proto.v1.GetCustomerFormGroupsResponse.
 * Use `create(GetCustomerFormGroupsResponseSchema)` to create a new message.
 */
export const GetCustomerFormGroupsResponseSchema: GenMessage<GetCustomerFormGroupsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 10);

/**
 * @generated from message api_proto.v1.GetCustomerRequest
 */
export type GetCustomerRequest = Message<"api_proto.v1.GetCustomerRequest"> & {
  /**
   * @generated from field: int64 customer_id = 1;
   */
  customerId: bigint;
};

/**
 * Describes the message api_proto.v1.GetCustomerRequest.
 * Use `create(GetCustomerRequestSchema)` to create a new message.
 */
export const GetCustomerRequestSchema: GenMessage<GetCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 11);

/**
 * @generated from message api_proto.v1.DeleteCustomerRequest
 */
export type DeleteCustomerRequest = Message<"api_proto.v1.DeleteCustomerRequest"> & {
  /**
   * @generated from field: int64 customer_id = 1;
   */
  customerId: bigint;
};

/**
 * Describes the message api_proto.v1.DeleteCustomerRequest.
 * Use `create(DeleteCustomerRequestSchema)` to create a new message.
 */
export const DeleteCustomerRequestSchema: GenMessage<DeleteCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 12);

/**
 * @generated from message api_proto.v1.DeleteMultipleCustomerRequest
 */
export type DeleteMultipleCustomerRequest = Message<"api_proto.v1.DeleteMultipleCustomerRequest"> & {
  /**
   * @generated from field: repeated int64 ids = 1;
   */
  ids: bigint[];
};

/**
 * Describes the message api_proto.v1.DeleteMultipleCustomerRequest.
 * Use `create(DeleteMultipleCustomerRequestSchema)` to create a new message.
 */
export const DeleteMultipleCustomerRequestSchema: GenMessage<DeleteMultipleCustomerRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_customer, 13);

/**
 * @generated from enum api_proto.v1.CustomerRank
 */
export enum CustomerRank {
  /**
   * @generated from enum value: CUSTOMER_RANK_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CUSTOMER_RANK_A = 1;
   */
  A = 1,

  /**
   * @generated from enum value: CUSTOMER_RANK_B = 2;
   */
  B = 2,

  /**
   * @generated from enum value: CUSTOMER_RANK_C = 3;
   */
  C = 3,

  /**
   * @generated from enum value: CUSTOMER_RANK_D = 4;
   */
  D = 4,

  /**
   * @generated from enum value: CUSTOMER_RANK_E = 5;
   */
  E = 5,
}

/**
 * Describes the enum api_proto.v1.CustomerRank.
 */
export const CustomerRankSchema: GenEnum<CustomerRank> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_customer, 0);

/**
 * @generated from enum api_proto.v1.SocialType
 */
export enum SocialType {
  /**
   * @generated from enum value: SOCIAL_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SOCIAL_TYPE_ANALYTICAL = 1;
   */
  ANALYTICAL = 1,

  /**
   * @generated from enum value: SOCIAL_TYPE_DRIVER = 2;
   */
  DRIVER = 2,

  /**
   * @generated from enum value: SOCIAL_TYPE_AMIABLE = 3;
   */
  AMIABLE = 3,

  /**
   * @generated from enum value: SOCIAL_TYPE_EXPRESSIVE = 4;
   */
  EXPRESSIVE = 4,
}

/**
 * Describes the enum api_proto.v1.SocialType.
 */
export const SocialTypeSchema: GenEnum<SocialType> = /*@__PURE__*/
  enumDesc(file_api_proto_v1_customer, 1);

